import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux'
import { FormGroup, Label, Input, Modal, ModalBody, ModalHeader, ModalFooter, Dropdown, DropdownToggle, DropdownItem } from "reactstrap"
import getValidatedForms from '../../../api/getValidatedForms';
import { addColumn } from '../../../redux/columnsSlice';
import { addForm } from '../../../redux/formsSlice';
import { addJoin } from '../../../redux/joinsSlice';

const AddJoin = ({ toggleModal, isModalOpen }) => {
    const forms = useSelector(state => state.forms)
    const selectedProject = useSelector(state => state.selectedProject);
    const columns = useSelector(state => state.columns);
    const dispatch = useDispatch()

    const selected = [0, 0];
    let { data } = useQuery("getValidatedForms" + selectedProject.name, () => getValidatedForms(selectedProject.name))
    let { data: availableForms = [] } = data || {}
    let selectedForm = availableForms[0];

    const selectFirstForm = (index) => selected[0] = Number(index);
    const selectSecondForm = (index) => selectedForm = availableForms[index];

    const confirmSelection = () => {
        dispatch(addForm(selectedForm))
        // dispatch(addColumn())
        dispatch(addJoin([selected[0], forms.length]));
        toggleModal();
    }

    return (
        <Modal isOpen={isModalOpen} toggle={toggleModal} >
            <ModalHeader toggle={toggleModal}>
                Select forms to join
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="exampleSelect">Sélectionner formulaire existant</Label>
                    <Input onChange={(e) => selectFirstForm(e.target.value)} className="mb-3" type="select" name="select" id="exampleSelect">
                        {forms.map((form, i) => <option value={i}>{form}</option>)}
                    </Input>
                    <Label for="exampleSelect">Selectionner nouveau formulaire</Label>
                    <Input onChange={(e) => selectSecondForm(e.target.value)} type="select" name="select" id="exampleSelect">
                        {availableForms.map((form, i) => <option value={i}>{form}</option>)}
                    </Input>

                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={confirmSelection}>Confirmer</Button>
                <Button variant="primary" onClick={toggleModal}>Annuler</Button>
            </ModalFooter>
        </Modal>
    )
}

export default AddJoin
